<template>
  <div class="main__section">
    <h1 class="section__title">
      {{ $t('clients') }}
    </h1>
    <div class="main__body">
      <div class="form-body">
        <h1 class="group__title">
          {{ $t('filter') }}
        </h1>
        <div class="form-group">
          <label>{{ $t('search') }}</label>
          <input class="large" type="text" :placeholder="$t('search')" v-model="search" v-on:keyup.enter="getClients()">
        </div>
      </div>
      <div class="form-body">
        <h1 class="group__title">
          {{ $t('clients') }} ({{ cClient }})
        </h1>
        <table class="table table-striped">
          <thead>
          <tr>
            <th scope="col">
              №
            </th>
            <th scope="col">{{ $t('FIO') }}</th>
            <th scope="col">{{ $t('phone') }} ({{ cClientPhone }})</th>
            <th scope="col">E-mail ({{ cClientEmail }})</th>
            <th scope="col">{{ $t('segment-participant') }}</th>
            <th scope="col">
              <img src="@/assets/social/telegram.svg">
            </th>
            <th scope="col">
              <img src="@/assets/social/viber.svg">
            </th>
            <th scope="col">
              <img src="@/assets/social/email.svg">
            </th>
            <th scope="col">
              <img src="@/assets/social/sms.svg">
            </th>
          </tr>
          </thead>
          <tbody v-if="clients.length > 0">
          <tr v-for="(item, index) in clients" v-bind:key="item.id">
            <th scope="row">
              {{ index + 1}}
            </th>
            <td class="pointer" v-on:click.self="showClientModal(item.id)">{{ (item.middlename ? item.middlename : '') + ' ' + (item.firstname ? item.firstname : '') + ' ' + (item.lastname ? item.lastname : '') }}</td>
            <td v-if="item.phone"><img src="@/assets/icon/check.svg"></td>
            <td v-else><img src="@/assets/icon/cross.svg"></td>
            <td v-if="item.email"><img src="@/assets/icon/check.svg"></td>
            <td v-else><img src="@/assets/icon/cross.svg"></td>
            <td>{{ item.segmentCount }}</td>
            <td>{{ item.telegramCount }}</td>
            <td>{{ item.viberCount }}</td>
            <td>{{ item.emailCount }}</td>
            <td>{{ item.smsCount }}</td>
          </tr>
          </tbody>
          <div class="tbody-empty" v-else>
            <p>Ничего не найдено</p>
          </div>
        </table>
        <div class="block__right-side">
          <a class="link-blue" @click="showImportModal">{{ $t('importing-clients-from-excel') }}</a>
        </div>
        <div class="form-row justify-content-center" v-if="clients.length < cClient && search === null || search === ''">
          <a class="btn" @click="nextPage">{{ $t('show-more') }}</a>
        </div>
        <div class="form-row mb-2">
          <a class="btn btn-primary" @click="showCreateClientModal">{{ $t('create-client') }}</a>
        </div>
      </div>
    </div>
    <createClientModal v-show="isModalCreateClientVisible"
                        @close="closeCreateClientModal"/>
    <clientModal :id="selectUser" v-show="isModalClientVisible"
                 @close="closeClientModal"/>
    <upload-excel-modal v-show="isModalImportVisible"
                        @close="closeImportModal"/>
    <loading :active.sync="isLoading"
             :can-cancel="true"
             :is-full-page="fullPage"></loading>
  </div>
</template>

<script>
import axios from 'axios'
import createClientModal from "../components/modal/createClientModal";
import clientModal from "../components/modal/clientModal";
import uploadExcelModal from "../components/modal/uploadExcelModal";
import loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
export default {
  name: 'clients',
  data: function(){
    return{
      clients: [],
      cClient: 0,
      cClientEmail: 0,
      cClientPhone: 0,
      page: 1,
      selectedClient: [],
      errors: [],
      isModalCreateClientVisible: false,
      isModalClientVisible: false,
      isModalImportVisible: false,
      selectUser: 0,
      selectAll: false,
      isLoading: false,
      fullPage: true,
      excelFile: null,
      search: null,
      dynamicSearch: {
        searchVarChar: {},
        searchDouble: {},
        searchDate: {},
      },
    }
  },
  created: function(){
    this.getClients();
  },
  mounted() {
    this.$root.$on('updateClients', () => {
      this.getClients();
    });
    this.$root.$on('startImport', () => {
      this.importClient();
    });
  },
  watch: {
    isModalImportVisible: function () {
      var $this = this;
      this.$root.$on('excel', function(val){
        $this.excelFile = val;
      });
    },
  },
  methods: {
    nextPage: function(){
      this.page++;
      this.getClients();
    },
    getClients: function(){
      this.isLoading = true;
      var data = {
        segment_id: '',
        search: this.search,
        dynamicSearch: this.dynamicSearch,
        page: this.page
      }
      axios.post('getClients', data).then(response => {
        var status = response.data.status;
        if(status){
          this.clients = response.data.clients;
          this.cClient = response.data.cClient;
          this.cClientEmail = response.data.cClientEmail;
          this.cClientPhone = response.data.cClientPhone;
          this.isLoading = false;
        }
      });
    },
    importClient: function(){
      this.isLoading = true;
      let formData = new FormData();
      formData.append('excel', this.excelFile);
      axios.post( 'importExcelClients', formData, { headers: {'Content-Type': 'multipart/form-data'}}).then(response => {
        let status = response.data.status;
        let savedUsers = response.data.countUsersSaved;
        if(status){
          this.errors = [];
          this.excelFile = null;
          this.getClients();
          this.$toast.success("Импорт успешно завершен"
              + "\nСохранено клиентов: " + savedUsers);
        }
        this.isLoading = false;
      })
    },
    deleteClient: function(id){
      this.isLoading = true;
      var data = {
        client_id: id
      }
      axios.post('deleteClient', data).then(response => {
        var status = response.data.status;
        if(status){
          this.getClients();
          this.isLoading = false;
          this.$toast.success("Клиент успешно удален");
        }
      });
    },
    showImportModal() {
      this.isModalImportVisible = true;
    },
    closeImportModal() {
      this.isModalImportVisible = false;
    },
    showCreateClientModal() {
      this.isModalCreateClientVisible = true;
    },
    closeCreateClientModal() {
      this.isModalCreateClientVisible = false;
    },
    showClientModal(id) {
      this.selectUser = id;
      this.isModalClientVisible = true;
    },
    closeClientModal() {
      this.isModalClientVisible = false;
    }
  },
  components: {
    createClientModal, loading, uploadExcelModal, clientModal
  }
}
</script>
